import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "What is the Moving Walls Market platform?",
    answer: "The Moving Walls Market (Online Self-Serve) platform is a digital marketplace where advertisers can independently create, manage, and book DOOH (Digital Out-of-Home) ad campaigns—without intermediaries.",
  },
  {
    question: "How do I create an account?",
    answer: "Click “Register” on the homepage and follow the on-screen instructions to register with your email.",
  },
  {
    question: "What payment methods are accepted?",
    answer: "Credit cards, debit cards, and supported payment gateways via Stripe.",
  },
  {
    question: "Are there any transaction fees?",
    answer: "Stripe processing fees may apply per transaction.",
  },
  {
    question: "How do I preview estimated impressions?",
    answer: "The platform provides a forecast based on screen traffic and your campaign budget.",
  },
  {
    question: "How do I upload creatives later?",
    answer: "You can skip uploading creatives during campaign creation and add them later through the Content Hub.However, we strongly recommend uploading and assigning creatives at least 48 hours before your campaign start date to avoid delays in approval or playback.",
  },
  {
    question: "Where do I view my active campaigns?",
    answer: "Under the Campaign Management tab, you can view all active, pending, and completed campaigns.",
  },
  {
    question: "What is the Proof of Play (PoP)?",
    answer: "Proof of Play is a report—either visual or data-based—that verifies your ad was displayed as scheduled.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="py-20 bg-gradient-to-br from-amber-50 to-green-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold leading-tight FontStyles mb-3 sm:mb-4">
            <span className="text-gray-900 block">Frequently Asked Questions</span>
          </h2>
          <p className="text-xl text-gray-600">
            A more platform-accurate FAQ is present here, addressing user concerns such as ad copy/brand eligibility, disqualification criteria, cancellation and refund policies etc.
          </p>
        </div>
        
        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem 
              key={index} 
              value={`item-${index}`}
              className="bg-white rounded-2xl shadow-sm border-0 px-6"
              data-testid={`faq-item-${index}`}
            >
              <AccordionTrigger className="text-left font-semibold py-6 hover:no-underline text-lg">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-gray-600 pb-6 leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
